import { useEffect, useState } from 'react'
import { useRoute } from 'wouter'
import { GroupSummary } from '@types'
import API from '@enums/api'

export default function useGroupPage() {
    const [match, params] = useRoute('/group/:groupId')
    const [error, setError] = useState<boolean>(false)
    const [errMessage, setErrMessage] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [group, setGroup] = useState<GroupSummary | undefined>()

    function packageReturn() {
        return {
            group,
            error,
            setError,
            errMessage,
            setErrMessage,
            loading,
            setLoading,
        }
    }

    async function getGroup(groupId: string) {
        const res = await API.ha.groups.getGroup(groupId)

        if (!res.ok) {
            setError(true)
            setErrMessage(`${res.status}: Failed to get Group!`)
            return undefined
        }

        console.log(res.value)

        return res.value
    }

    async function init() {
        setLoading(true)

        if (!match) {
            setError(true)
            setErrMessage('No Group ID provided!')
            setLoading(false)
            return
        }

        const res = await getGroup(params.groupId)

        setGroup(res)

        setLoading(false)
    }

    useEffect(() => {
        init()
    }, [params?.groupId])

    return packageReturn()
}
